import React, { useEffect, useState } from "react";
import {
  getVisitAction,
  updateRejectVisitAction,
  updateVisitAction,
} from "../../Actions/VisitAction/VisitAction";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlineSaveAlt } from "react-icons/md";
import { createRejectAction } from "../../Actions/RejectAction/RejectAction";

const RejectModal = ({ closeModal, patientId }) => {
  const getVisit = useSelector((state) => state.getVisit);
  const { visits, loading } = getVisit;
  const [visitId, setVisitId] = useState(null);
  const dispatch = useDispatch();
  const [note, setNote] = useState(null);
  const [dateManualy, setDateManualy] = useState(null);
    
  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setDateManualy(formattedDate);
  }, []);
  const createUnderGoneSurgery = useSelector(
    (state) => state.createUnderGoneSurgery
  );
  const { surgeries } = createUnderGoneSurgery;
  // console.log(visits)
  useEffect(() => {
    dispatch(getVisitAction(patientId));
  }, [patientId]);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (note == null || note == "" || visitId == null || visitId == "") {
      return;
    } else {
      dispatch(createRejectAction(visitId, note, patientId,dateManualy));
      closeModal();
    }
  };
  return (
    <div className="modal">
      <div className="modal-overlay">
        <div className="modal-container w-4/12 mt-2">
          <div className="modal-header items-center justify-between flex gap-3">
            <h3 onClick={closeModal} className="cursor-pointer">
              X
            </h3>
            <div>
              <select
                name=""
                onChange={(e) => setVisitId(e.target.value)}
                className="input w-full"
                id=""
              >
                <option value="-1">Select Visit</option>
                {visits?.map((visit, index) => {
                  return (
                    <option key={index} value={visit.id}>
                      {visit?.created_at?.split("T")[0]}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          {visitId == null || visitId == -1 ? (
            ""
          ) : (
            <form action="">

              <div className="flex flex-col">
                <label htmlFor="date">Date</label>
                <input
                  type="date"
                  name=""
                  className="input mt-2 w-full"
                  id="date"
                  value={dateManualy}
                  onChange={(e) => setDateManualy(e.target.value)}
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="note">Note *</label>
                <textarea
                  name=""
                  className="input mt-2 w-full"
                  id="note"
                  placeholder="note"
                  onChange={(e) => setNote(e.target.value)}
                  value={note}
                ></textarea>
              </div>
              <div>
                <button
                  onClick={handleSubmit}
                  className="btn-info flex gap-2 mt-2 items-center"
                >
                  Save <MdOutlineSaveAlt />
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default RejectModal;
